/* eslint-disable angular/controller-as */
angular.
module("digiexam").
controller("DxMonitorExamInfoController", function MonitorExamInfoController(
	$scope,
	dxDialog
) {
	"use strict";

	$scope.close = function close() {
		dxDialog.closeMostRecent();
	};
});
